import { LegalEntityAuditGroupAuditModel } from "../../legalEntityAuditGroupOverview/LegalEntityAuditGroupOverview.types";
import { useTranslation } from "../../../localization/useTranslation";
import { useStateUrlParamsArray } from "../../../common/hooks/useStateUrlParams";
import { IManagementReportExcludedAudits } from "./ManagementReportExcludedAudits";
import { filterBySelection, toSelectOptions } from "@common/components/managementReport/managementReportFilters";

export function useManagementReportExcludedAuditsHooks(props: IManagementReportExcludedAudits) {
    const [searchedStatus, setSearchedStatus] = useStateUrlParamsArray("exclusionReason", []);

    const { translateLegalEntityAuditStatus } = useTranslation();

    const audits: Array<LegalEntityAuditGroupAuditModel> = props.audits ?? [];

    const exclusionFilterOptions = toSelectOptions(
        audits.map((audit) => ({ id: audit.status.toString(), name: translateLegalEntityAuditStatus(audit.status.toString()) }))
    );

    return {
        rows: filterBySelection(audits, searchedStatus, (row) => row.status.toString()),
        exclusionFilterOptions,
        searchedStatus,
        setSearchedStatus,
    };
}
